!function (e, t) {
  if ("object" == typeof exports && "object" == typeof module) module.exports = t(require("react"));else if ("function" == typeof define && define.amd) define(["react"], t);else {
    var o = t("object" == typeof exports ? require("react") : e.react);
    for (var n in o) ("object" == typeof exports ? exports : e)[n] = o[n];
  }
}(this, function (e) {
  return function (e) {
    function t(n) {
      if (o[n]) return o[n].exports;
      var r = o[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(r.exports, r, r.exports, t), r.l = !0, r.exports;
    }
    var o = {};
    return t.m = e, t.c = o, t.i = function (e) {
      return e;
    }, t.d = function (e, o, n) {
      t.o(e, o) || Object.defineProperty(e, o, {
        configurable: !1,
        enumerable: !0,
        get: n
      });
    }, t.n = function (e) {
      var o = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return t.d(o, "a", o), o;
    }, t.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, t.p = "", t(t.s = 2);
  }([function (e, t) {
    e.exports = {
      detected: function detected() {
        return blockedElement = document.createElement("div"), blockedElement.className = "pub_300x250 pub_300x250m pub_728x90 text-ad textAd text_ad text_ads text-ads", blockedElement.setAttribute("style", "position: absolute; top: -10px; left: -10px; width: 1px; height: 1px;"), document.body.appendChild(blockedElement), null != window.document.body.getAttribute("abp") || null == blockedElement.offsetParent || 0 == blockedElement.offsetHeight || 0 == blockedElement.offsetLeft || 0 == blockedElement.offsetTop || 0 == blockedElement.offsetWidth || 0 == blockedElement.clientHeight || 0 == blockedElement.clientWidth;
      }
    };
  }, function (t, o) {
    t.exports = e;
  }, function (e, t, o) {
    "use strict";

    function n(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function r(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }
    function c(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = o(1),
      l = o(0),
      u = i.PropTypes.node,
      f = function (e) {
        function t() {
          var e, o, c, i;
          n(this, t);
          for (var u = arguments.length, f = Array(u), p = 0; p < u; p++) f[p] = arguments[p];
          return o = c = r(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(f))), c.state = {
            detected: !1
          }, c.componentDidMount = function () {
            c.setState({
              detected: (0, l.detected)()
            });
          }, c.render = function () {
            return c.state.detected ? c.props.children : null;
          }, i = o, r(c, i);
        }
        return c(t, e), t;
      }(i.Component);
    f.displayName = "AdBlockDetect", f.propTypes = {
      children: u
    }, t.default = f;
  }]);
});